// Bridges the gap between "user sent a message" and "browser has a URL for
// that conversation". The URL only picks up the conversation id once the
// turn finishes (see Hermes.tsx's history.replace effect), so a reload or
// navigation away mid-stream would otherwise strand the user on a blank new
// conversation even though the backend kept working and stored the result.
const LAST_SENT_CONVERSATION_KEY = "hermes_last_sent_conversation";

export function rememberLastSentConversation(conversationId: string): void {
  try {
    localStorage.setItem(LAST_SENT_CONVERSATION_KEY, conversationId);
  } catch {
    // Storage can throw (private browsing, quota) — losing this is a UX
    // regression, not a functional failure, so fail silently.
  }
}

export function forgetLastSentConversation(): void {
  try {
    localStorage.removeItem(LAST_SENT_CONVERSATION_KEY);
  } catch {
    // See rememberLastSentConversation.
  }
}

export function getLastSentConversationId(): string | null {
  try {
    return localStorage.getItem(LAST_SENT_CONVERSATION_KEY);
  } catch {
    return null;
  }
}
